import React from "react";
import Cookies from "js-cookie";
import "./cookies.scss";
import { useCookies } from "../../hooks/useCookies";

const CookiePopup = () => {
  const { createTheCookies } = useCookies();
  const userId = localStorage.getItem("userId");

  const handleAccept = async () => {
    Cookies.set("cookieConsent", "true", { expires: 365 });
    // save the cookie choices on API
    const personalizationCookies = true;
    const analyticsCookies = true;
    const marketingCookies = true;
    const functionalCookies = true;
    const cookiesResponse = await createTheCookies(
      userId,
      functionalCookies,
      personalizationCookies,
      analyticsCookies,
      marketingCookies
    );
    if (typeof cookiesResponse === "string") {
      throw new Error(cookiesResponse);
    }
    window.location.reload();
  };

  const handleDecline = async () => {
    Cookies.set("cookieConsent", "false", { expires: 365 });

    // save reject on APIS

    const personalizationCookies = false;
    const analyticsCookies = false;
    const marketingCookies = false;
    const functionalCookies = true;
    const cookiesResponse = await createTheCookies(
      userId,
      functionalCookies,
      personalizationCookies,
      analyticsCookies,
      marketingCookies
    );
    if (typeof cookiesResponse === "string") {
      throw new Error(cookiesResponse);
    }

    window.location.reload();
  };

  return (
    <div className="cookie-popup">
      <span>We use cookies!</span>
      <div className="cookie-text">
        We use cookies to enhance your browsing experience, analyze site
        traffic, and personalize content. By clicking "Accept All Cookies," you
        agree to the storage of cookies on your device.
      </div>
      <a
        href="https://oncoscreen.health/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy policy
      </a>
      <div>
        <button className="accept-button" onClick={handleAccept}>
          Accept All
        </button>
        <button className="reject-button" onClick={handleDecline}>
          Reject All
        </button>
      </div>
    </div>
  );
};
export default CookiePopup;
